module.exports = __webpack_public_path__ + "media/images/bus/conditions/PANDUS-06a1d59532c0d10aed999e08e2c38331.svg";